
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7156"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7156"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h8njB", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $c79544eb718958da$export$6503ec6e8aabbaf; }, function (v) { return $c79544eb718958da$export$6503ec6e8aabbaf = v; });
var $c79544eb718958da$export$6503ec6e8aabbaf;
var $c79544eb718958da$export$f7ad0328861e2f03;
"use strict";
var $c79544eb718958da$var$mapping = new Map();
function $c79544eb718958da$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c79544eb718958da$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c79544eb718958da$var$resolve(id) {
    var resolved = $c79544eb718958da$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c79544eb718958da$export$6503ec6e8aabbaf = $c79544eb718958da$var$register;
$c79544eb718958da$export$f7ad0328861e2f03 = $c79544eb718958da$var$resolve;

});

var $e38b64d10ee189d1$exports = {};

(parcelRequire("h8njB")).register(new URL("", import.meta.url).toString(), JSON.parse('["5HXwy","mnist-autoencoder.4fef599c.js","dfXxP","mnist-encoder-leakyRelu.9959ebf5.json","dvrhk","mnist-decoder-leakyRelu.04cbcc36.json","51qfN","mnist-encoder-relu.9959ebf5.json","64Q53","mnist-decoder-relu.4c7275b8.json","cB2Kj","mnist-encoder-sigmoid.9959ebf5.json","jd5aj","mnist-decoder-sigmoid.4deabd85.json","lLRLb","binary-classification.4f800f39.js"]'));


var $9bnV0 = parcelRequire("9bnV0");
var $040503b0c16f31dc$exports = {};
$040503b0c16f31dc$exports = new URL("mnist-encoder-leakyRelu.9959ebf5.json", import.meta.url).toString();


var $1ffe0707d7cfcbc3$exports = {};
$1ffe0707d7cfcbc3$exports = new URL("mnist-decoder-leakyRelu.04cbcc36.json", import.meta.url).toString();


var $4ae5e50c5fa7d027$exports = {};
$4ae5e50c5fa7d027$exports = new URL("mnist-encoder-relu.9959ebf5.json", import.meta.url).toString();


var $bbec8fe4fa51f5ab$exports = {};
$bbec8fe4fa51f5ab$exports = new URL("mnist-decoder-relu.4c7275b8.json", import.meta.url).toString();


var $e8006f8f5ea968f6$exports = {};
$e8006f8f5ea968f6$exports = new URL("mnist-encoder-sigmoid.9959ebf5.json", import.meta.url).toString();


var $f0f177f8ca9278f0$exports = {};
$f0f177f8ca9278f0$exports = new URL("mnist-decoder-sigmoid.4deabd85.json", import.meta.url).toString();


const { Autoencoder: $8f3ec252d768b6e3$var$Autoencoder, bootstrapModel: $8f3ec252d768b6e3$var$bootstrapModel } = (0, $9bnV0.utils);
var $8f3ec252d768b6e3$export$2e2bcd8739ae039 = async (activation)=>{
    const encoderPath = activation === "leakyRelu" && (0, (/*@__PURE__*/$parcel$interopDefault($040503b0c16f31dc$exports))) || activation === "relu" && (0, (/*@__PURE__*/$parcel$interopDefault($4ae5e50c5fa7d027$exports))) || (0, (/*@__PURE__*/$parcel$interopDefault($e8006f8f5ea968f6$exports)));
    const decoderPath = activation === "leakyRelu" && (0, (/*@__PURE__*/$parcel$interopDefault($1ffe0707d7cfcbc3$exports))) || activation === "relu" && (0, (/*@__PURE__*/$parcel$interopDefault($bbec8fe4fa51f5ab$exports))) || (0, (/*@__PURE__*/$parcel$interopDefault($f0f177f8ca9278f0$exports)));
    const [encoderWeights, decoderWeights] = await Promise.all([
        fetch(encoderPath).then((res)=>res.json()),
        fetch(decoderPath).then((res)=>res.json())
    ]);
    const encoder = $8f3ec252d768b6e3$var$bootstrapModel(encoderWeights, activation);
    const decoder = $8f3ec252d768b6e3$var$bootstrapModel(decoderWeights, activation);
    return new $8f3ec252d768b6e3$var$Autoencoder(encoder, decoder);
};



var $3P6oo = parcelRequire("3P6oo");
const $4058a72cde329015$var$fetchTestData = async ()=>{
    const response = await fetch(`${""}/api/mnist?end=50&type=test`);
    const json = await response.json();
    return json;
};
const $4058a72cde329015$var$drawImage = (image)=>{
    const imageCanvas = document.createElement("canvas");
    const size = 14;
    const scale = size * 8;
    imageCanvas.width = scale;
    imageCanvas.height = scale;
    const ctx = imageCanvas.getContext("2d");
    const imageData = ctx.createImageData(size, size);
    image.forEach((pixel, idx)=>{
        const value = pixel * 255;
        imageData.data[idx * 4 + 0] = value;
        imageData.data[idx * 4 + 1] = value;
        imageData.data[idx * 4 + 2] = value;
        imageData.data[idx * 4 + 3] = 255;
    });
    // Create a temporary canvas to scale the image
    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = size;
    tempCanvas.height = size;
    const tempCtx = tempCanvas.getContext("2d");
    tempCtx.putImageData(imageData, 0, 0);
    // Scale up the image and draw it on the image canvas
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(tempCanvas, 0, 0, size, size, 0, 0, scale, scale);
    return imageCanvas;
};
let $4058a72cde329015$var$testData = null;
let $4058a72cde329015$var$currentIteration = null;
const $4058a72cde329015$var$getSelectedActivation = ()=>document.querySelector('input[name="activation"]:checked').value;
const $4058a72cde329015$var$iterateImages = (id)=>async (autoencoder)=>{
        if (!$4058a72cde329015$var$testData) $4058a72cde329015$var$testData = await $4058a72cde329015$var$fetchTestData();
        for (const { image: original } of $4058a72cde329015$var$testData){
            if ($4058a72cde329015$var$currentIteration !== id) break;
            const decoded = autoencoder.forward(original);
            const reconstructed = decoded.map(({ data: pixel })=>pixel > 0.5 ? 1 : 0);
            document.getElementById("original").innerHTML = "";
            document.getElementById("reconstructed").innerHTML = "";
            document.getElementById("original").appendChild($4058a72cde329015$var$drawImage(original));
            document.getElementById("reconstructed").appendChild($4058a72cde329015$var$drawImage(reconstructed));
            await new Promise((resolve)=>{
                setTimeout(resolve, 2000);
            });
        }
    };
const $4058a72cde329015$var$main = async ()=>{
    const activation = $4058a72cde329015$var$getSelectedActivation();
    const autoencoder = await (0, $8f3ec252d768b6e3$export$2e2bcd8739ae039)(activation);
    $4058a72cde329015$var$currentIteration = Math.random();
    $4058a72cde329015$var$iterateImages($4058a72cde329015$var$currentIteration)(autoencoder);
    const size = Math.min(+document.querySelector(".demo").offsetWidth, 600);
    (0, $3P6oo.default)("#architecture", size, autoencoder.toString());
};
document.querySelectorAll('input[name="activation"]').forEach((radio)=>{
    radio.addEventListener("change", ()=>{
        if ($4058a72cde329015$var$currentIteration) $4058a72cde329015$var$currentIteration = null;
        $4058a72cde329015$var$main();
    });
});
$4058a72cde329015$var$main();


//# sourceMappingURL=mnist-autoencoder.4fef599c.js.map
